import { render, staticRenderFns } from "./CombineTable.vue?vue&type=template&id=5bd39d13&"
import script from "./CombineTable.vue?vue&type=script&lang=js&"
export * from "./CombineTable.vue?vue&type=script&lang=js&"
import style0 from "./CombineTable.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports